// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4cf3b6d5","820":"a4a07597","989":"2503342c"}[chunkId] + ".chunk.js";
};